"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// Constants
exports.API_URL = 'https://api.pokemontcg.io';
exports.API_VERSION = '1';
// Classes
__export(require("./classes/card"));
__export(require("./classes/set"));
__export(require("./classes/meta"));
//# sourceMappingURL=sdk.js.map